import { FC, useCallback, useMemo, useState } from 'react';
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { Form, Input, Button } from 'src/common';
import debounce from 'lodash/debounce';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch } from '@fortawesome/pro-light-svg-icons';
import useBidsSearchArgs from 'src/reactiveVars/BidsSearchArgsVar';

interface IFormState {
  search: string;
}

export const BidsSearch: FC = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [searchVar, updateSearch] = useBidsSearchArgs();

  const initialValues: IFormState = useMemo(() => {
    return { search: '' };
  }, []);
  const onValuesChange = useMemo(
    () =>
      debounce((changedValues: Partial<IFormState>) => {
        updateSearch({
          ...searchVar,
          search: changedValues.search
        });
      }, 300),
    [searchVar, updateSearch]
  );

  const [searchFocus, setSearchFocus] = useState(false);
  const onFocus = useCallback(() => setSearchFocus(true), []);
  const onBlur = useCallback((event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    if (!value) {
      setSearchFocus(false);
    }
  }, []);

  const onClearSearch = useCallback(() => {
    form.setFieldsValue({ search: '' });
    updateSearch({ ...searchVar, search: undefined });
  }, [form, searchVar, updateSearch]);

  const needClear = useMemo(() => {
    return (!!searchVar.search && !!searchVar.search.length) || false;
  }, [searchVar.search]);

  return (
    <Form form={form} initialValues={initialValues} onValuesChange={onValuesChange} className={styles.form}>
      <div className={styles.search}>
        <Form.Item name={'search'} className={classNames(styles.searchField, { [styles.isFocus]: searchFocus })}>
          <Input
            placeholder={t('Common.search')}
            onBlur={onBlur}
            onFocus={onFocus}
            className={styles.searchInput}
            suffix={
              needClear ? (
                <Button
                  type={'text'}
                  onClick={onClearSearch}
                  className={styles.button}
                  icon={<FontAwesomeIcon icon={faTimes} />}
                />
              ) : (
                <FontAwesomeIcon icon={faSearch} className={styles.iconSearch} />
              )
            }
          />
        </Form.Item>
      </div>
    </Form>
  );
};
export default BidsSearch;
